<!-- staff-app/src/App.vue -->
<template>
  <router-view />
</template>

<script>
import "@/scripts/notifications/staffNotifications";

export default {
  name: "App",
};
</script>
